/**
 * @desc 财务画像-历史处罚
 * @author caoyx
 */
import React, { PureComponent } from 'react';
import SSE from './subComponents/SSE';
import CSRCPunishment from './subComponents/CSRCPunishment';
import {changeAnchor} from '../common/commons';
import { isNotEmpty } from '../../../utils/util';

export default class HistoryPunishment extends PureComponent {
    constructor(props) {
        super(props);
    }

    szseNav = (nav) => {
        let title = [
            { name: '证监会-行政处罚', id: 'punishment' },
            { name: '证监会-监管措施', id: 'punishment-adminis-measures' },
            { name: '海关总署失信企业信息', id: 'chain-customs' },
            { name: '经营异常', id: 'abnormal-operation' },
            { name: '保监局行政处罚', id: 'IRB-adminis' },
            { name: '行政处罚', id: 'adminis' },
            // { name: '行政监管措施', id: 'adminis-regulatory' },
            // { name: '问询历史', id: 'inquiry-history' },
            // { name: '监管函件', id: 'regulatory-letters' },
            { name: '税务处罚', id: 'tax-punish' },
            { name: '海关处罚', id: 'customs-sanction' }
            ], szse = [];
        if(isNotEmpty(nav)) {
            szse = [
                ...nav,
                ...title
            ];
            changeAnchor(szse);
        } else {
            changeAnchor(title);
        }
    }

    render() {
        return (
            <div>
                <SSE szseNav={this.szseNav} />
                <CSRCPunishment />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/historyPunishment/HistoryPunishment.jsx